// Shared by both fulfill flows: the credit-allocation enums their payloads carry.
import { createYesNoOptions } from '@/config/formOptions';
import { UNIT_TYPES } from '@/config/unitTypes.constants';

// The UI's own yes/no wording; each flow's DTO builder turns this into the boolean the server expects.
export const RETIRE_CREDITS = Object.freeze({
  yes: 'YES',
  no: 'NO',
});

export const buildRetireCreditsOptions = createYesNoOptions(RETIRE_CREDITS);

// A config row's `layout`: sized from the summary card's grid instead of the full form width.
export const FULFILL_ROW_LAYOUT = Object.freeze({
  summaryAnchored: 'summaryAnchored',
  summaryAnchoredHalves: 'summaryAnchoredHalves',
});

// Allocate credit's own unitType → the server's payload enum.
export const FULFILL_UNIT_TYPE = Object.freeze({
  [UNIT_TYPES.working]: 'WORKING_UNIT',
  [UNIT_TYPES.declaration]: 'DISPLAY_UNIT',
});

// The reverse — a payload's unitType back to the basis its quantities were read in.
export const FULFILL_UNIT_TYPE_BASIS = Object.freeze(
  Object.fromEntries(
    Object.entries(FULFILL_UNIT_TYPE).map(([unitType, payloadType]) => [payloadType, unitType]),
  ),
);
